import React from "react";
import ListItem from "./listItem";

const List = ({ list, expanded, root, onClick, onExpandToggle }) => {
  const menuClassname =
    !root && !expanded
      ? "menu-expandlist-content contracted"
      : "menu-expandlist-content ";
  return (
    <ul
      {...(!root && { className: menuClassname })}
      {...(root && { className: "navtree" })}
      aria-hidden={expanded}
      id={root ? "navtree" : ""}
    >
      {list.map((li) => (
        <ListItem
          key={li.navTreeID}
          item={li}
          type={li.typeID}
          expanded={li.expanded}
          active={li.active}
          onClick={onClick}
          onExpandToggle={onExpandToggle}
        />
      ))}
    </ul>
  );
};

export { List };
